import './site.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import configureAppStore from './store/configureStore';
import { setDefaultOptions } from 'esri-loader';
import { Root } from './components/Root';
import { ApplicationState } from './store/stores/ApplicationState';

setDefaultOptions({
    url: 'https://js.arcgis.com/next/',
});

const store = configureAppStore({} as ApplicationState);
(async () => {
    console.log("configuring app");
    const domNode = document.getElementById('app');
    if (domNode == null) {
        throw "No DOM element found to mount application.";
    }
    const root = createRoot(domNode);
    root.render(
        <React.StrictMode>
            <ReduxProvider store={store}>
                <Root />
            </ReduxProvider>
        </React.StrictMode>
    );
})();
